import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBars,
    faCalendarDays,
    faCompass,
    faMagnifyingGlass,
    faMap,
    faTableColumns,
    faXmark
} from "@fortawesome/free-solid-svg-icons";
import {AppScreen} from "../app-screen";
import './header.scss';

export type HeaderProps = {
    hasData: boolean,
    showNavigation: boolean,
    activeScreen: AppScreen
}

export default function Header({
    hasData,
    showNavigation,
    activeScreen
}: HeaderProps) {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const closeDrawer = () => setIsDrawerOpen(false);

    useEffect(() => {
        if (!isDrawerOpen) return;

        const closeOnEscape = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                closeDrawer();
            }
        };

        document.addEventListener('keydown', closeOnEscape);

        return () => document.removeEventListener('keydown', closeOnEscape);
    }, [isDrawerOpen]);

    useEffect(() => {
        if (!showNavigation) {
            closeDrawer();
        }
    }, [showNavigation]);

    return (
        <div className={`app-header ${isDrawerOpen ? 'is-drawer-open' : ''}`}>
            <div className="app-header__inner">
                <Link to={hasData ? '/dashboard' : '/'} className="app-header__brand" aria-label="BirdMap Explorer home">
                    <img src="/assets/birdmap-logo-v2.svg" alt="BirdMap Explorer" className="app-header__logo" />
                </Link>
                {showNavigation ?
                    <>
                        <button
                            type="button"
                            className="app-header__menu-button"
                            aria-label={isDrawerOpen ? 'Close navigation menu' : 'Open navigation menu'}
                            aria-expanded={isDrawerOpen}
                            aria-controls="primary-navigation"
                            onClick={() => setIsDrawerOpen(current => !current)}
                        >
                            <FontAwesomeIcon icon={isDrawerOpen ? faXmark : faBars} aria-hidden="true" />
                        </button>
                        <div className="app-header__drawer-backdrop" onClick={closeDrawer} aria-hidden="true" />
                        <nav id="primary-navigation" className="app-header__nav" aria-label="Primary navigation">
                            <Link
                                to={hasData ? '/dashboard' : '/'}
                                className={`app-header__nav-item ${activeScreen === AppScreen.Dashboard ? 'is-active' : ''}`}
                                onClick={closeDrawer}
                            >
                                <FontAwesomeIcon icon={faTableColumns} aria-hidden="true" />
                                Dashboard
                            </Link>
                            {hasData ?
                                <>
                                <Link
                                    to="/map"
                                    className={`app-header__nav-item ${activeScreen === AppScreen.Map ? 'is-active' : ''}`}
                                    onClick={closeDrawer}
                                >
                                    <FontAwesomeIcon icon={faMap} aria-hidden="true" />
                                    Map
                                </Link>
                                <Link
                                    to="/calendar"
                                    className={`app-header__nav-item ${activeScreen === AppScreen.Calendar ? 'is-active' : ''}`}
                                    onClick={closeDrawer}
                                >
                                    <FontAwesomeIcon icon={faCalendarDays} aria-hidden="true" />
                                    Calendar
                                </Link>
                                <Link
                                    to="/family-explorer"
                                    className={`app-header__nav-item ${activeScreen === AppScreen.FamilyExplorer ? 'is-active' : ''}`}
                                    onClick={closeDrawer}
                                >
                                    <FontAwesomeIcon icon={faMagnifyingGlass} aria-hidden="true" />
                                    Family Explorer
                                </Link>
                                <Link
                                    to="/hotspot-explorer"
                                    className={`app-header__nav-item ${activeScreen === AppScreen.HotspotExplorer ? 'is-active' : ''}`}
                                    onClick={closeDrawer}
                                >
                                    <FontAwesomeIcon icon={faMap} aria-hidden="true" />
                                    Hotspot Explorer
                                </Link>
                                <Link
                                    to="/discover"
                                    className={`app-header__nav-item ${[AppScreen.Discover, AppScreen.BigYear].includes(activeScreen) ? 'is-active' : ''}`}
                                    onClick={closeDrawer}
                                >
                                    <FontAwesomeIcon icon={faCompass} aria-hidden="true" />
                                    Discover
                                </Link>
                                </> :
                                null
                            }
                        </nav>
                    </>
                    : null
                }
            </div>
        </div>
    )
}
